import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "components-lib";

// Custom components
import { KifaytiLogoIcon as HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
  <HorizonLogo h='64px' w='64px' my='5px' color={logoColor} />
      <HSeparator mb='10px' />
    </Flex>
  );
}

export default SidebarBrand;
